module.exports = __webpack_public_path__ + "img/buenos_aires_saavedra.b0a159f0.jpg";